import React from 'react';
import { Anchor, Box, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { CUSTOMER_SUPPORT_LINK } from '../../../constants/urls';
import { ExitReason } from '../../../../../models';
import { useIdVerificationCallbacks } from '../../../contexts/IdVerificationContext';

interface GenericErrorProps {
  id: string;
}

export default function GenericError({ id }: GenericErrorProps) {
  const { currentSubStep } = useWizard();
  const { onExit } = useIdVerificationCallbacks();

  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Done',
        renderBackButton: () => null,
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onExit({ reason: ExitReason.GenericError, success: false });
      }}
      render={() => (
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
          <Icon size="lg" css={{ color: 'icon.neutral' }}>
            <IconRateUnhappyFilled />
          </Icon>
          <Heading level={2} textStyle="heading-sm">
            Something went wrong!
          </Heading>
          <Paragraph>
            We are unable to process your request to verify your identity at this time. Contact{' '}
            <Anchor href={CUSTOMER_SUPPORT_LINK} target="_blank" rel="noopener noreferrer">
              customer support
            </Anchor>{' '}
            for help.
          </Paragraph>
        </Box>
      )}
    />
  );
}
